import * as Sentry from "@sentry/astro";

Sentry.init({
  dsn: "https://67e46816fdf3285e9272de46291c9d39@o4511107849060352.ingest.us.sentry.io/4511107854368768",
  // Adds request headers and IP for users, for more info visit:
  // https://docs.sentry.io/platforms/javascript/guides/astro/configuration/options/#sendDefaultPii
  sendDefaultPii: true,
});